import { render, staticRenderFns } from "./SearchApproved.vue?vue&type=template&id=6219afcd&scoped=true&"
import script from "./SearchApproved.vue?vue&type=script&lang=js&"
export * from "./SearchApproved.vue?vue&type=script&lang=js&"
import style0 from "./SearchApproved.vue?vue&type=style&index=0&id=6219afcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6219afcd",
  null
  
)

export default component.exports